import { hasAuthority } from '@/utils/permission'

/**
 * 权限校验指令
 * @author Ych Tu
 */

function checkAuthority(el: HTMLElement, binding: any) {
  const { value } = binding

  const parent = el.parentNode

  if (!parent) {
    return
  }

  if (!hasAuthority(value)) {
    if (parent.contains(el)) {
      parent.removeChild(el)
    }
  }
}

export default {
  mounted(el: HTMLElement, binding: any) {
    checkAuthority(el, binding)
  },
  updated(el: HTMLElement, binding: any) {
    checkAuthority(el, binding)
  }
}
